import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import RamSlotTypeahead from './RamSlotTypeahead';

export const RamSlot = ({
    fromRamSlot,
    toRamSlot,
    onChange,
    disabled,
    classes,
    t
}) => (
    <Box className={classes.specificationWrapper}>
        <InputLabel
            className={classes.inputLabelSpecification}
            shrink
            variant="standard"
        >
            {t('ramSlot')}
        </InputLabel>
        <Box className={classes.SpecificationBox}>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <RamSlotTypeahead
                    animatedPlaceholder
                    labelId="from"
                    isClearable
                    name="from"
                    value={fromRamSlot}
                    onChangeSuggestion={onChange('fromRamSlotTypes')}
                    disabled={disabled}
                    t={t}
                />

            </FormControl>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <RamSlotTypeahead
                    animatedPlaceholder
                    labelId="to"
                    isClearable
                    name="to"
                    value={toRamSlot}
                    onChangeSuggestion={onChange('toRamSlotTypes')}
                    disabled={disabled}
                    t={t}
                />
            </FormControl>
        </Box>
    </Box>
);
